import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {CookieConsentDialogComponent} from '../cookie-consent-dialog/cookie-consent-dialog.component';
import {COOKIE_CONSENT, getCookie} from '../config/cookies.config';

@Component({
    selector: 'app-cookie-consent',
    templateUrl: '../login-page/login-page.component.html',
    styleUrls: ['../login-page/login-page.component.scss'],
    standalone: false
})
export class CookieConsentComponent implements OnInit {
  loading = false;
  loginFailed = false;

  private dialogRef: MatDialogRef<CookieConsentDialogComponent> | null = null;

  constructor(private router: Router, private dialog: MatDialog) {}

  ngOnInit(): void {
    if (getCookie(COOKIE_CONSENT)) {
      this.router.navigate(['/login']);
      return;
    }

    this.dialogRef = this.dialog.open(CookieConsentDialogComponent, {
      height: 'auto',
      width: '600px',
      panelClass: 'cookies-modal',
      disableClose: true
    });

    this.dialogRef.afterClosed().subscribe(() => {
      window.location.href = '/login';
    });
  }
  tryLogin(): void {}
}
